<template>
    <div>
        <card-header title='New Enrollment Option' icon="fa-plus"/>

        <card-body>
            <course-config-form :config="newConfig"/>
        </card-body>

        <card-footer class="pt-3 pb-3">
            <div class="columns">
                <div class="column has-text-right">
                    <b-button
                        type="is-primary"
                        size="is-small"
                        @click="submit"
                        :disabled="!newConfig.title"
                    ><i class="fas fa-plus mr-2"></i>Create Enrollment Option</b-button>
                </div>
            </div>
        </card-footer>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardFooter from "@/TIER/components/CardFooter";
    import CourseConfigForm from "./ConfigForm";

    import {client as http} from "@/http_client";

    export default {
        components: {CourseConfigForm, CardHeader, CardBody, CardFooter},
        props: ['card', 'props'],
        data() {
            return {
                newConfig: {
                    title: '',
                    price: '0',
                    units: '0',
                    is_enabled: 1,
                    is_hidden: 0
                }
            }
        },
        methods: {
            submit: function() {
                this.$emit('loading', true);
                const payload = {
                    ...this.newConfig,
                    course_id: this.props.courseId
                };

                http.post('/courses/' + this.props.courseId + '/configs', payload, {force: true}).then(response => {
                    this.$reloadCard('course-configs', {courseId: this.props.courseId});
                    this.$closeCard(this.card);
                }).catch(err => {
                    window.alert('An error occurred while creating the enrollment option.');
                    this.$emit('loading', false);
                });
            }
        },
        mounted() {
            this.$emit('loading', false);
        }
    }
</script>
